export class SousCategorie {
    id?: number;
    name?: string;                  // Français
    namearabe?: string;             // Arabe
    nameanglais?: string;           // ✅ NEW: Anglais
    website?: string;
    category?: string;
    image_url?: string;
    listimages?: string[];
    description?: string;           // Français
    descriptionarabe?: string;      // Arabe
    descriptionanglais?: string;    // ✅ NEW: Anglais
    prix?: string;
    video?: string;                 // ✅ NEW: URL vidéo (nullable)
    displayOrder?: number;
}